<template>
  <v-app>
    <v-main :class="containerState">
      <v-container id="editor-container" :fluid="true">
        <VueFlowEditor
          id="viewport-flow"
          :realm="realm"
          :api="mfConfig.api"
          :apiDraw="mfConfig.apiDraw"
          :apiChat="mfConfig.apiChat"
        ></VueFlowEditor>
        <v-overlay v-model="overlay" class="align-center justify-center">
          <v-progress-circular
            color="primary"
            size="64"
            indeterminate
          ></v-progress-circular>
        </v-overlay>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import utils from "@/mixins/utils.js";
import VueFlowEditor from "./components/VueFlowEditor.vue";

export default {
  name: "MashupEditor",
  components: { VueFlowEditor },
  mixins: [utils],
  props: ["mfConfig", "realm"],
  data() {
    return {
      containerState: "expanded",
      overlay: false,
    };
  },
  mounted() {

    document.addEventListener("language-localstorage-changed", (event) => {
      this.setLocale(event.detail.storage);
    });

    this.containerState =
      localStorage.getItem("sidenav") === "opened" ? "reduced" : "expanded";

    document.addEventListener("sidenav-localstorage-changed", (event) => {
      this.containerState =
        event.detail.storage === "opened" ? "reduced" : "expanded";
    });

    document.addEventListener("toggle-overlay", (event) => {
      this.overlay = event.detail.released;
    });
  },
};
</script>
<style scoped>

main.expanded {
  margin-left: 56px;
}
main.expanded header#upp-bar {
  margin-left: 56px;
}
main.reduced {
  margin-left: 256px;
}
main.reduced header#upp-bar {
  margin-left: 256px;
}
iframe {
  border: 0;
}
#editor-container {
  overflow-y: hidden;
  padding: 0;
  height: 100%;
}

@media only screen and (max-width: 768px) {
  main.expanded #editor-container {
    margin-top: 78px;
  }

  main.reduced #editor-container {
    margin-top: 58px;
    height: 100%;
  }
}
</style>
